import {CodeName} from "../../stocks/models/code-name";

export class DialogOptions{
    constructor(){
        this.init()
    }
    public okTxt: string;
    public yesTxt: string;
    public noTxt: string;
    public cancelTxt: string;
    public okTitle: string;
    public yesTitle: string;
    public noTitle: string;
    public cancelTitle: string;
    public okOrder: number;
    public yesOrder: number;
    public noOrder: number;
    public cancelOrder: number;

    public init = (): void => {
        this.okTxt = 'Ok';
        this.yesTxt = 'Yes';
        this.noTxt = 'No';
        this.cancelTxt = 'Cancel';
        this.okTitle = '';
        this.yesTitle = '';
        this.noTitle = '';
        this.cancelTitle = '';
        this.okOrder = 0;
        this.yesOrder = 0;
        this.noOrder = 0;
        this.cancelOrder = 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/dialogOptions.ts